"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _reactRedux = require("react-redux");

var _SalesforceCampaigns = require("lead-flows-ui/actions/SalesforceCampaigns");

var _SalesforceCampaigns2 = require("lead-flows-ui/selectors/SalesforceCampaigns");

var _UISelect = _interopRequireDefault(require("UIComponents/input/UISelect"));

var _UIFormLabel = _interopRequireDefault(require("UIComponents/form/UIFormLabel"));

var _UILoadingSpinner = _interopRequireDefault(require("UIComponents/loading/UILoadingSpinner"));

var SalesForceCampaignSelect =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SalesForceCampaignSelect, _PureComponent);

  function SalesForceCampaignSelect() {
    (0, _classCallCheck2.default)(this, SalesForceCampaignSelect);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SalesForceCampaignSelect).apply(this, arguments));
  }

  (0, _createClass2.default)(SalesForceCampaignSelect, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      var fetchSfdcSettings = this.props.fetchSfdcSettings;
      fetchSfdcSettings();
    }
  }, {
    key: "getLangKey",
    value: function getLangKey(suffix) {
      return "leadFlowEditor.leadFlowOptionsEditor." + suffix;
    }
  }, {
    key: "getCampaignSelectOptions",
    value: function getCampaignSelectOptions() {
      var campaigns = this.props.campaigns;
      return campaigns.map(function (campaign) {
        return {
          value: campaign.id,
          text: campaign.name
        };
      });
    }
  }, {
    key: "renderLoadingContent",
    value: function renderLoadingContent() {
      return _react.default.createElement(_UILoadingSpinner.default, {
        grow: true,
        minHeight: 100
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          sfdcSyncEnabled = _this$props.sfdcSyncEnabled,
          selectedCampaignId = _this$props.selectedCampaignId,
          onChange = _this$props.onChange;

      if (!sfdcSyncEnabled) {
        return null;
      }

      return _react.default.createElement("div", {
        className: "salesforce-campaign-selector"
      }, _react.default.createElement(_UIFormLabel.default, {
        htmlFor: "bar"
      }, _react.default.createElement(_FormattedMessage.default, {
        message: this.getLangKey('salesforceCampaignTitle')
      })), _react.default.createElement(_UISelect.default, {
        placeholder: _react.default.createElement(_FormattedMessage.default, {
          message: this.getLangKey('salesforceCampaignSelectionDefault')
        }),
        options: this.getCampaignSelectOptions(),
        onChange: onChange,
        value: selectedCampaignId,
        clearable: true
      }));
    }
  }], [{
    key: "propTypes",
    get: function get() {
      return {
        selectedCampaignId: _react.PropTypes.string,
        onChange: _react.PropTypes.func.isRequired,
        sfdcSyncEnabled: _react.PropTypes.bool.isRequired,
        sfdcSettingsRequestState: _react.PropTypes.object.isRequired,
        campaignsRequestState: _react.PropTypes.object.isRequired,
        fetchSfdcSettings: _react.PropTypes.func.isRequired,
        fetchSfdcCampaigns: _react.PropTypes.func.isRequired,
        campaigns: _react.PropTypes.array.isRequired
      };
    }
  }]);
  return SalesForceCampaignSelect;
}(_react.PureComponent);

var mapStateToProps = function mapStateToProps(state) {
  return {
    sfdcSyncEnabled: (0, _SalesforceCampaigns2.getSfdcSyncEnabled)(state),
    sfdcSettingsRequestState: (0, _SalesforceCampaigns2.getSfdcSettingsRequestState)(state),
    campaigns: (0, _SalesforceCampaigns2.getSfdcCampaigns)(state),
    campaignsRequestState: (0, _SalesforceCampaigns2.getSfdcCampaignsRequestState)(state)
  };
};

var actionsToBind = {
  fetchSfdcSettings: _SalesforceCampaigns.fetchSfdcSettings,
  fetchSfdcCampaigns: _SalesforceCampaigns.fetchSfdcCampaigns
};

var _default = (0, _reactRedux.connect)(mapStateToProps, actionsToBind)(SalesForceCampaignSelect);

exports.default = _default;
module.exports = exports.default;